import * as Reducer from './slice';

export interface IAppState {
  // this feature state
  [Reducer.statePropName]: Reducer.IAppState;
}

const getAppState = (state: IAppState) => state[Reducer.statePropName];

export const isLoading = (state: IAppState) => getAppState(state).loading;

export const getEvents = (state: IAppState) => getAppState(state).events;

export const getFilter = (state: IAppState) => getAppState(state).filter;

export const getCategories = (state: IAppState) => getAppState(state).categories;

export const getFilteredEvents = (state: IAppState) => getAppState(state).filteredEvents;
